import Vue from "vue";
import Vuetify from "vuetify/lib";

import colors from "vuetify/lib/util/colors";

Vue.use(Vuetify);

export default new Vuetify({
  rtl: true,
  theme: {
    themes: {
      light: {
        primary: colors.cyan.darken4,
        secondary: colors.red.lighten4,
        accent: colors.indigo.base,
      },
    },
  },
});
